import {isAtLeastAiChatSize} from '@AiChat/hooks/useAiChatSize';
import {getOrderedImageActions} from './image-actions.registry';
import type {ImageActionDescriptor, ResolvedImageActions, ResolveImageActionsParams} from './image-actions.types';
import {INLINE_SLOT_BUDGET} from './image-actions.types';

export function resolveImageActions({size, context}: ResolveImageActionsParams): ResolvedImageActions {
  const available = getOrderedImageActions().filter((descriptor): boolean => {
    return descriptor.isAvailable(context);
  });

  const fitsInline = (descriptor: ImageActionDescriptor): boolean => {
    if (!descriptor.isInlineEligible(context)) {
      return false;
    }

    if (descriptor.minimumInlineSize === null) {
      return false;
    }

    return isAtLeastAiChatSize(size, descriptor.minimumInlineSize);
  };

  const pinned = available.filter((descriptor): boolean => {
    return descriptor.isPinnedInline === true && fitsInline(descriptor);
  });
  const budgeted = available
    .filter((descriptor): boolean => {
      return descriptor.isPinnedInline !== true && fitsInline(descriptor);
    })
    .slice(0, INLINE_SLOT_BUDGET[size]);
  const inline = available.filter((descriptor): boolean => {
    return pinned.includes(descriptor) || budgeted.includes(descriptor);
  });
  const overflow = available.filter((descriptor): boolean => {
    return !inline.includes(descriptor);
  });

  return {inline, overflow};
}
